import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import { AngularFireStorage } from 'angularfire2/storage';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})



export class FaqComponent implements OnInit, AfterViewInit {

  private questionCollections: AngularFirestoreCollection<Question>;
  private faqBanner: Observable<string | null>;
  questions: Observable<Question[]>;

  constructor(private afs: AngularFirestore, private auth: AngularFireAuth, private storage: AngularFireStorage) { }

  ngOnInit() {
    this.faqBanner = this.storage.ref('/public/faqBanner.jpeg').getDownloadURL();
    this.questionCollections = this.afs.collection<Question>('faq');
    this.questions = this.questionCollections.valueChanges();
  }

  ngAfterViewInit() {
  }
}

export class Question {
  question: string;
  answer: string;
}



// WEBPACK FOOTER //
// ./src/app/faq/faq.component.ts